/**
 * B_Shape.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Define from 'canvas/base/dev/util/B_Define';

const B_Shape = (function(superclass) {

	const $ = {
		_shape : null,
		_bg : null,
		_bgColor : null,
		_line : null,
		_lineColor : null
	}

	class B_Shape extends superclass {

		constructor (obj) {
			super(obj);

			// [S] strResType, object
			this._strResType = B_Define.ARR_RES_TYPE[3];
			this._object = new createjs.Shape();
			this._container.addChild(this._object);
		}

		// [F]

		// @OVERRIDING
		_setArea(w, h) {
			if(super._checkArea(w,h)) {

			}
		}

		// @OVERRIDING
		_setPoint(px, py) {
			if(super._checkReg(px, py)) {
				this._object.regX = this._w * this._pointX / 100;
				this._object.regY = this._h * this._pointY / 100;
			}
		}

	}

	return B_Shape;
});

export default B_Shape;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/shape/B_Shape.js